export const ACTION_GET_SUPPLIERS = "ACTION_GET_SUPPLIERS";
export const ACTION_POST_CREATE_SUPPLIERS = "ACTION_POST_CREATE_SUPPLIERS";
export const ACTION_PUT_UPDATE_SUPPLIERS = "ACTION_PUT_UPDATE_SUPPLIERS";
export const ACTION_DELETE_SUPPLIERS = "ACTION_DELETE_SUPPLIERS";